const jsonStringValidator = (rule, value, callback) => {
  if (!value) {
    callback(new Error("Поле не может быть пустым"));
  } else {
    try {
      JSON.parse(value);
      callback();
    } catch (error) {
      callback(new Error("Поле должно быть валидным JSON"));
    }
  }
};
const requiredValidator = (rule, value, callback) => {
  if (!value) {
    callback(new Error("Поле не может быть пустым"));
  } else {
    callback();
  }
};

export default [
  {
    type: "bitzlato",
    title: "Bitzlato P2P",
    fields: [
      {
        type: "input",
        key: "email",
        label: "E-mail аккаунта",
        validator: requiredValidator
      },
      {
        type: "text",
        key: "secret",
        label: "Ключи аккаунта",
        isJSON: true,
        validator: jsonStringValidator
      },
      {
        type: "input",
        key: "kid",
        label: "Номер ключа kid",
        validator: requiredValidator
      }
    ]
  },
  {
    type: "whitebit",
    title: "WhiteBit",
    fields: [
      {
        type: "input",
        key: "apiKey",
        label: "Ключ API",
        validator: requiredValidator
      },
      {
        type: "input",
        key: "apiSecret",
        label: "Секрет API",
        validator: requiredValidator
      }
    ]
  },
  {
    type: "okx",
    title: "OKX",
    fields: [
      {
        type: "input",
        key: "apiKey",
        label: "Ключ API",
        validator: requiredValidator
      },
      {
        type: "input",
        key: "secretKey",
        label: "Секретный ключ",
        validator: requiredValidator
      },
      {
        type: "input",
        key: "passphrase",
        label: "Парольная фраза",
        validator: requiredValidator
      }
    ]
  },
  {
    type: "firekassa",
    title: "Firekassa",
    fields: [
      {
        type: "input",
        key: "token",
        label: "Токен сайта",
        validator: requiredValidator
      }
    ]
  },
  {
    type: "vanilapay",
    title: "Vanilapay",
    fields: [
      {
        type: "input",
        key: "token",
        label: "Токен сайта",
        validator: requiredValidator
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/pages/Ledger/components/Balances/credentialTypes.js